/* eslint-disable functional/prefer-readonly-type */
import React from 'react'
import { Grid } from '@mui/material'
import { State } from '@hookstate/core'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import FieldAutocompleteRegistration from '~/components/FieldAutocompleteRegistration'
import { IObjectType } from '~/features/Management/interfaces'
import ICircunstance from '~/features/Circunstance/interfaces/ICircunstance'
import IDestination from '~/features/Destination/interfaces/IDestination'

interface ObjectFiltersProps {
  readonly objectType: State<IObjectType | null>
  readonly objectCircunstance: State<ICircunstance | null>
  readonly destinationObjectId: State<IDestination | null>
  readonly getDestinations: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getObjectTypes: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly getCircunstances: <T = Record<string, string>>(id?: string) => Promise<readonly T[]>
  readonly translate: (key: string) => string
  readonly disableFields?: boolean
  readonly setStartDate: (date: string | null) => void
  readonly setFinishDate: (date: string | null) => void
  readonly initialPeriod: State<string>
}

export default function ObjectFilters({
  objectType,
  objectCircunstance,
  destinationObjectId,
  getObjectTypes,
  getCircunstances,
  getDestinations,
  translate,
  disableFields,
  setStartDate,
  setFinishDate,
  initialPeriod,
}: ObjectFiltersProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          valueId={objectType.get()?.id as string}
          label={translate('Object Type')}
          onValueChange={(value) => objectType.set(value)}
          optionsFetch={getObjectTypes}
          disabled={disableFields}
        />
      </Grid>

      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          label={translate('Circunstance')}
          onValueChange={(objectCircunstanceItem) =>
            objectCircunstance.set(objectCircunstanceItem)
          }
          valueId={objectCircunstance.get()?.id as string}
          optionsFetch={getCircunstances}
          disabled={disableFields}
        />
      </Grid>
      <Grid item xs={2}>
        <FieldAutocompleteRegistration
          label={translate('Destination')}
          onValueChange={(destination) => destinationObjectId.set(destination)}
          valueId={destinationObjectId.get()?.id as string}
          optionsFetch={getDestinations}
          disabled={disableFields}
        />
      </Grid>
      <FilterSelectPeriod
        required
        onStartDateChange={(value) => setStartDate(value?.toJSON() ?? null)}
        onFinishDateChange={(value) => setFinishDate(value?.toJSON() ?? null)}
        onPeriodChange={(value) => initialPeriod.set(value)}
        period={initialPeriod.get()}
        sxPeriod={{ pl: 0, pt: 0 }}
        sxInitialDate={{ pl: 1, pt: 0 }}
        sxFinalDate={{ pl: 1, pt: 0 }}
      />
    </Grid>
  )
}
